var $name="i18n",$path="configs/i18n.js",$this={$name,$path,};module.exports = {
  attributes: {
    country: 'data-se-country-code',
    language: 'data-se-language-code',
  },
};
